import {observer} from "mobx-react";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import { useEffect } from "react";
import currentPortalStore from "../../stores/current-portal-store";
import uiSettingsStore from "../../stores/ui-settings-store";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";
import ManageReturnsRedesignToggle from "./components/manage-returns-redesign-toggle/manage-returns-redesign-toggle";
import ManageReturnsRedesignPromoModal from "./components/manage-returns-redesign-promo-modal/manage-returns-redesign-promo-modal";
import dashboardSettingsStore from "../../stores/dashboard-settings-store";
import {
    buildManageReturnsDesignPath,
    getPreferredManageReturnsListPath,
    isManageReturnsDesignToggleVisible,
    isManageReturnsRedesignAvailable,
    shouldUseNewManageReturnsDesign,
} from "./utils/manage-returns-redesign-rollout";
import { APP_PATHS } from "../../constants/app-paths";

const ManageReturnsPage: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const { rmaId } = useParams();
    const isRmaListPage = !rmaId;
    const navigate = useNavigate();

	useEffect(() => {
        currentPortalStore.load();
        uiSettingsStore.load();
    }, []);

    // Soft nav lands on the old tree by default; prefer redesign only when shop feature + opt-in allow it.
    useEffect(() => {
        if (
            !uiSettingsStore.isLoaded ||
            !dashboardSettingsStore.areSettingsLoaded ||
            !shouldUseNewManageReturnsDesign()
        ) {
            return;
        }
        navigate(buildManageReturnsDesignPath(true, rmaId), { replace: true });
    }, [
        rmaId,
        uiSettingsStore.isLoaded,
        uiSettingsStore.manageReturnsNewEnabled,
        dashboardSettingsStore.areSettingsLoaded,
        dashboardSettingsStore.manageReturnsRedesignAvailable,
        navigate,
    ]);

    const onBackButtonClick = () => {
        navigate(getPreferredManageReturnsListPath() ?? APP_PATHS.RETURNS);
    }

    const isRedesignAvailable = isManageReturnsRedesignAvailable();

    const shouldShowPromo =
        isRedesignAvailable &&
        isRmaListPage &&
        uiSettingsStore.isLoaded &&
        !uiSettingsStore.manageReturnsNewEnabled &&
        !uiSettingsStore.manageReturnsPromoDeclined;

	return (
		<BasePageLayout
            title={getTranslation('MANAGE_RETURNS', 'dashboard-returns-page')}
            backButtonCallback={onBackButtonClick}
            titleActions={isRmaListPage && isManageReturnsDesignToggleVisible() ? <ManageReturnsRedesignToggle /> : undefined}
        >
            {shouldShowPromo && <ManageReturnsRedesignPromoModal />}
			<Outlet />
		</BasePageLayout>
	)
});

export default ManageReturnsPage;